// eslint-disable-next-line operator-linebreak
export const freezeGenericMessage = `
    <div 
        class="spinner-grow" 
        style="height: 1.25rem; width: 1.25rem;" 
        role="status">
    </div>&nbsp;Actualizando datos ...
`;

export const defaultHeaderDropDown = [
    {
        label: "Filtrar",
        action(column) {
            const filtersRowIsVisible =
                this.header.querySelector(".dt-row-filter").style.display !==
                "none";

            if (filtersRowIsVisible === false) {
                this.columnmanager.toggleFilter(true);
            }

            this.columnmanager.focusFilter(column.colIndex);
        },
    },
    {
        label: "Limpiar filtros",
        action() {
            const filters = Array.from(
                this.header.querySelectorAll(".dt-filter"),
            );

            filters.forEach((filter) => {
                filter.value = "";
            });

            this.columnmanager.applyFilter({});

            this.columnmanager.toggleFilter(false);

            setTimeout(() => {
                this.rowmanager.collapseAllNodes();
            }, 1);
        },
    },
    {
        label: "Ordenar ascendente",
        action(column) {
            this.sortColumn(column.colIndex, "asc");
        },
    },
    {
        label: "Ordenar descendente",
        action(column) {
            this.sortColumn(column.colIndex, "desc");
        },
    },
    {
        label: "Reiniciar ordenamiento",
        action(column) {
            this.sortColumn(column.colIndex, "none");
        },
    },
    {
        label: "Eliminar columna",
        action(column) {
            this.removeColumn(column.colIndex);
        },
    },
];

export function borrarDefaultDropDownOptions(dataTable) {
    const dataTableDefaultDropdownOptions = Array.from(
        dataTable.wrapper.querySelectorAll(".dt-dropdown__list-item"),
    )
        .filter((dropdownItem) => {
            const itemIndex = Number(dropdownItem.dataset.index).valueOf();
            const itemBuscado =
                itemIndex === 0 ||
                itemIndex === 1 ||
                itemIndex === 2 ||
                itemIndex === 3;

            return itemBuscado === true ? dropdownItem : null;
        })
        .filter((item) => item !== null);

    dataTableDefaultDropdownOptions.forEach((dropdownItem) => {
        dropdownItem.parentElement.removeChild(dropdownItem);
    });
}

export function setShowCheckStatus(
    dataTable = null,
    nombreFila = "",
    accionFila = "",
) {
    dataTable.rowmanager.showCheckStatus = () => {
        if (!dataTable.options.checkedRowStatus) return;

        const checkedRows = dataTable.rowmanager.getCheckedRows();
        const count = checkedRows.length;
        const rowName = nombreFila;
        const rowAction = accionFila;
        const plural = count > 1 ? "s" : "";

        if (count > 0) {
            dataTable.bodyRenderer.showToastMessage(
                `${count} ${rowName}${plural} ${rowAction}${plural}`,
            );
            setTimeout(() => {
                dataTable.bodyRenderer.clearToastMessage();
            }, 2000);
        } else {
            dataTable.bodyRenderer.clearToastMessage();
        }
    };
}

const registerEventListenerDataTable = (dataTable, callback) => {
    const dataTableWrapper = dataTable.wrapper;

    const rows = dataTableWrapper.querySelectorAll(
        ".dt-row.vrow .dt-cell__content",
    );

    rows.forEach((row) => {
        row.addEventListener("click", callback, true);
    });
};

/**
 * Crea un listener (click) sobre la DataTable especificada
 * @param {DataTable} dataTable
 * @param {Function} callback función a ejecutar en el evento
 */
export const setOnClickEventDataTable = (dataTable, callback) => {
    registerEventListenerDataTable(dataTable, callback);

    // override method DataTable.restoreState
    dataTable.bodyRenderer.restoreState = () => {
        dataTable.rowmanager.highlightCheckedRows();
        dataTable.cellmanager.selectAreaOnClusterChanged();
        dataTable.cellmanager.focusCellOnClusterChanged();

        registerEventListenerDataTable(dataTable, callback);
    };
};
